import { Component, Input, ChangeDetectorRef, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MapZonesService } from 'app/shared/components';
import { BaseComponent } from 'app/shared/components/base/base.component';
import { Subscription } from 'rxjs';
import { FeedSectionHandler } from '../../entities/shared/feed.section';

@Component({
    selector: 'key-admin-feed',
    templateUrl: './feed.component.html',
    providers: [MapZonesService],
    standalone: false
})
export class AdminFeedComponent extends BaseComponent implements OnChanges, OnDestroy {

    @Input() entity: any;
    @Input() handler: FeedSectionHandler;

    @Input() visible = false;

    settingChangedSubscrition: Subscription;

    constructor(
        public i18n: TranslateService,
        private ref: ChangeDetectorRef,
    ) {
        super();
    }

    ngOnDestroy() {
        if (this.settingChangedSubscrition) {
            this.settingChangedSubscrition.unsubscribe();
        }
    }

    ngOnChanges(_changes: SimpleChanges) {
        if (this.handler && this.visible) {
            if (!this.settingChangedSubscrition) {
                this.settingChangedSubscrition = this.handler.onSettingsChanged.subscribe(() => {
                    this.ref.markForCheck();
                });
            }
        }
    }

}
